import React, { createContext, useState, ReactNode } from 'react';

interface DataAbouTitleProps {
	title: string;
	subtitle: string;
}

const dataInitial: DataAbouTitleProps = {
	title: 'CMS - Mondelez',
	subtitle: ''
};

interface TitleNavBarProviderProps {
	dataAbouTitle: DataAbouTitleProps;
	setDataAbouTitle: React.Dispatch<React.SetStateAction<DataAbouTitleProps>>;
	resetState: () => void;
}

const TitleNavBarContext = createContext<TitleNavBarProviderProps>({
	dataAbouTitle: dataInitial,
	setDataAbouTitle: () => {},
	resetState: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function TitleNavBarProvider({ children }: ContextProps) {
	const [dataAbouTitle, setDataAbouTitle] =
		useState<DataAbouTitleProps>(dataInitial);

	function resetState() {
		setDataAbouTitle(dataInitial);
	}

	return (
		<TitleNavBarContext.Provider
			value={{ dataAbouTitle, setDataAbouTitle, resetState }}
		>
			{children}
		</TitleNavBarContext.Provider>
	);
}

export default TitleNavBarContext;
